export class TutorialStep {
    static Start    = 0;
    static Step1    = 1;
    static Finished = 9999;
}

export default class TutorialState {
    constructor() {
        this.steps = [
            TutorialStep.Start,
            TutorialStep.Step1,
            TutorialStep.Finished
        ];
        this.swipeLearned = false;
        this.index = 0;
        this.forceShowTutorial = false;
        this.staticTutorial = false;
    }

    get currentStep() {
        return this.steps[this.index];
    }

    restart() {
        if ( !this.staticTutorial ) {
            this.swipeLearned = false;
        }
        this.index = 0;
    }

    start(isStatic = false) {
        if ( isStatic ) {
            this.staticTutorial = true;
            this.swipeLearned = true;
        }
        this.index = 1;
    }

    finish() {
        this.index = this.steps.length - 1;
        this.forceShowTutorial = false;
    }

    nextStep() {
        if ( ( this.index + 1 ) >= this.steps.length ) {
            return;
        }

        this.index++;
    }

    prevStep() {
        if ( ( this.index - 1 ) < this.steps.length ) {
            return;
        }

        this.index--;
    }
}
